import { DatePickerRange } from '../../../components';
import { useAtom } from 'jotai';
import { dateRangeState } from '../../../state';


export const AgencyDateRangePicker = () => {
    const [dateRange, setDateRangeState] = useAtom(dateRangeState);

    return (
        <DatePickerRange
            onChange={(dates) => {
                setDateRangeState(dates);
            }}
            defaultValue={dateRange ?? undefined}
        />
    );
};

